import stockMessage from "../../helpers/stockMessage/stockMessage";
import stockMessageInputs from "../stock-status/stockMessageInputs";

export default function productOptionStockStatus({ variant, quantity }) {
  const allocatedComponents = window.cartData?.allocatedComponents || {};
  const inputs = stockMessageInputs({
    variant,
    quantityRequested: quantity,
    allocatedComponents,
  });

  const messages = {
    inStock: {
      inStock: true,
      status: "inStock",
    },
    lowStock: {
      inStock: true,
      status: "lowStock",
    },
    outOfStock: {
      inStock: false,
      status: "outOfStock",
    },
    reserveNow: {
      inStock: false,
      status: "reserveNow",
    },
    reserveNowDate: {
      inStock: false,
      status: "reserveNowDate",
    },
    notifyMe: {
      inStock: false,
      status: "notifyMe",
    },
    notifyMeDate: {
      inStock: false,
      status: "notifyMeDate",
    },
    madeToOrder: {
      inStock: false,
      status: "madeToOrder",
    },
  };

  const message = stockMessage({ ...inputs, messages });

  return {
    ...message,
    backorderDate: inputs.backorderDate,
  };
}
